exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-47ff3932] {\n  display: flex;\n  align-items: center;\n  gap: 12px 40px;\n  flex-wrap: wrap;\n  padding: 8px;\n  margin-bottom: 12px;\n}\n.search_block[data-v-47ff3932] {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.search label[data-v-47ff3932] {\n  margin: 0;\n}\n.search select[data-v-47ff3932] {\n  background: #fff;\n  height: 29px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  outline: none;\n}", ""]);

// exports
